export default Object.freeze({
  display: (value) => {
    return value === "T" ? "진열" : "진열안함";
  },
  selling: (value) => {
    return value === "T" ? "판매중" : "판매안함";
  },
  certStatus: (value) => {
    if (value === "inactivated") {
      return "미인증";
    } else if (value === "activated") {
      return "인증완료";
    } else if (value === "lost") {
      return "분실";
    } else {
      return "-";
    }
  },
  defaultString: (value) => {
    return !value ? "-" : value;
  },
  defaultDate: (value) => {
    if (!value) {
      return "-";
    } else {
      let date = value.split(" ");
      return `${date[0]}</br>${date[1]}`;
    }
  },
  numberFormat: (value) => {
    if (!value) {
      return value;
    } else {
      value += "";
      let whole, fraction;
      let decIndex = value.lastIndexOf(".");
      if (decIndex > 0) {
        whole = value.substr(0, decIndex);
        fraction = value.substr(decIndex);
      } else {
        whole = value;
      }
      let rgx = /(\d+)(\d{3})/;
      while (rgx.test(whole)) {
        whole = whole.replace(rgx, "$1" + "," + "$2");
      }
      return fraction ? whole + fraction : whole;
    }
  },
  validatedAndExpiredAt: (data) => {
    if (data.cert_validated_at && data.cert_expired_at) {
      let validatedAt = data.cert_validated_at.substr(0, 10);
      let expiredAt = data.cert_expired_at.substr(0, 10);
      return `${validatedAt}</br>~${expiredAt}`;
    } else {
      return "-";
    }
  },
  comma: (value) => {
    let len, point, str;

    value = value + "";
    point = value.length % 3;
    len = value.length;

    str = value.substring(0, point);
    while (point < len) {
      if (str != "") str += ",";
      str += value.substring(point, point + 3);
      point += 3;
    }

    return str;
  },
  dateConversion: (value) => {
    const items = {
      W: "주",
      M: "달",
      Y: "년",
    };

    let count = value.replace(/[a-z]/gi, "");
    let type = value.replace(/[0-9]/g, "");

    return `${count}${items[type]}`;
  },
  percentWonConversion: (value) => {
    let items = {
      P: "%",
      W: "원",
    };

    if (value === 0) {
      return "-";
    }

    let count = value.replace(/[a-z]/gi, "");

    let type = value.replace(/[0-9]/g, "");

    if (type == "W") {
      let len, point, str;
      count = count + "";
      point = count.length % 3;
      len = count.length;

      str = count.substring(0, point);
      while (point < len) {
        if (str != "") str += ",";
        str += count.substring(point, point + 3);
        point += 3;
      }
      count = str;
    } else {
      type = type.replace(/\./g, "");
    }

    return `${count}${items[type]}`;
  },
  memberStatusConversion: (value) => {
    let str = "";

    if (value == "enabled") {
      str = "가입중";
    } else if (value == "disabled") {
      str = "만료";
    } else if (value == "unsubscribe") {
      str = "가입중<br>(해지 예정)";
    } else {
      str = "해지";
    }

    return `${str}`;
  },

  memberDiscountConversion: (value) => {
    let str = "";

    if (value == "T") {
      str = "정기결제";
    } else {
      str = "1회결제";
    }

    return `${str}`;
  },
  paymentMethodConversion: (value) => {
    let str = "";

    if (value == "card") {
      str = "카드결제";
    } else {
      str = "무통장";
    }

    return `${str}`;
  },
  pointSubscriptionConversion: (value) => {
    let str = "";
    if (value) {
      let date = value.split(" ");
      str = `${date[0]}일 ${date[1]}`;
    }

    return `${str}`;
  },
  percentWonUnitConversion: (value) => {
    let items = {
      P: "%",
      W: "원",
    };

    return `${items[value]}`;
  },

  trim: (value) => {
    let str = value.trim();
    return `${str}`;
  },
});
